import { ContentFieldSchema } from "@/types/template";
import type { ContentField } from "@/types/template";

/** Parse a TipTap fieldDef JSON string into a validated ContentField, or null on failure. */
export function parseFieldDef(raw: string): ContentField | null {
  try {
    const result = ContentFieldSchema.safeParse(JSON.parse(raw));
    return result.success ? result.data : null;
  } catch {
    return null;
  }
}
